import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, watch, ref } from 'vue'
    import { guid } from '@common/Guid'
    import { copyToClipboard } from '@common/Common'
    import { useRouter, useOrganizationUnitId } from '@common/composables'
    import { useMyAccessTokensPage } from '@Organizations/AccessTokens/pages-core'

    
export default /*#__PURE__*/_defineComponent({
  __name: 'MyAccessTokensPage',
  setup(__props) {

    document.title = "Manage access tokens"

    const router = useRouter()

    const id = ref()
    const secret = ref()
    const copied = ref(false)

    const {
        useCurrentUserQuery,
        useUserAccessTokensQuery,
        useGenerateAccessTokenCommand,
        useRevokeAccessTokenCommand,
    } = useMyAccessTokensPage()

    const accessToken = computed(() => btoa(`${id.value}/${secret.value}`))

    const { modelCurrentUserQueryV1, runCurrentUserQueryV1 } = useCurrentUserQuery()
    const userId = computed(() => modelCurrentUserQueryV1.value?.UserId)
    const organizationUnitId = computed(() => modelCurrentUserQueryV1.value?.OrganizationUnitId)

    const { modelUserAccessTokensQueryV1, runUserAccessTokensQueryV1, succeed: succeedUserAccessTokensQueryV1 } = useUserAccessTokensQuery(userId)
    const accessTokens = computed(() => modelUserAccessTokensQueryV1.value?.AccessTokens || [])

    const { invokeGenerateAccessTokenCommandV1, succeedGenerateAccessTokenCommandV1 } = useGenerateAccessTokenCommand(id, organizationUnitId, userId, secret)

    const { invokeRevokeAccessTokenCommandV1, succeedRevokeAccessTokenCommandV1 } = useRevokeAccessTokenCommand(null, userId)

    onMounted(() => runCurrentUserQueryV1())

    watch(userId, () => runUserAccessTokensQueryV1())

    watch(succeedGenerateAccessTokenCommandV1, () => runUserAccessTokensQueryV1())
    watch(succeedRevokeAccessTokenCommandV1, () => runUserAccessTokensQueryV1())

    function handleGenerateAccessTokenCommandV1() {
        id.value = guid()
        secret.value = `${guid()}${guid()}`.replace(/-/g, '')
        invokeGenerateAccessTokenCommandV1()
    }

    function handleRevokeAccessTokenCommandV1(token) {
        if (confirm(`Do you really want to revoke access token ${token.Name}?`)){
            invokeRevokeAccessTokenCommandV1({id: token.Id})
        }
    }

    function handleCopyToClipboard() {
        copyToClipboard(accessToken.value)
        copied.value = true

        const h = setTimeout(() => {{
            copied.value = false
            clearTimeout(h)
        }}, 1000)
    }

return { __sfc: true,router, id, secret, copied, useCurrentUserQuery, useUserAccessTokensQuery, useGenerateAccessTokenCommand, useRevokeAccessTokenCommand, accessToken, modelCurrentUserQueryV1, runCurrentUserQueryV1, userId, organizationUnitId, modelUserAccessTokensQueryV1, runUserAccessTokensQueryV1, succeedUserAccessTokensQueryV1, accessTokens, invokeGenerateAccessTokenCommandV1, succeedGenerateAccessTokenCommandV1, invokeRevokeAccessTokenCommandV1, succeedRevokeAccessTokenCommandV1, handleGenerateAccessTokenCommandV1, handleRevokeAccessTokenCommandV1, handleCopyToClipboard }
}

})